<template>
  <div class="new-page-con">
    <div class="layout_header">
      <Header> </Header>
    </div>
    <!-- 工具栏 -->
    <ToolBar
      :ToolBarData="toolBarData"
      @select="handleSelect"
      @download="handleDownload"
    />
    <div class="dataServices-page bulkData-container">
      <div class="bulkData-block">
        <div class="bulkData-block-title">Fleid Selection</div>
        <div class="bulkData-select-con">
          <div class="bulkData-select-con-left">
            <el-collapse
              v-model="selectActiveNames"
              accordion
              class="bulkData-category-collapse"
            >
              <el-collapse-item title="Data Range" name="1">
                <template slot="title">
                  <img
                    class="collapse-iconimg"
                    src="@/assets/images/dataServices/bulkData-img/select.png"
                  />
                  Data Range
                  <span class="category-collapse-head-tip"
                    >( Per parameter, max 3 selections. )</span
                  >
                </template>
                <div class="bulkData-category-select-box">
                  <div class="bulkData-category-select-item">
                    <div class="bulkData-category-select-title">Country</div>
                    <el-select
                      v-model="form.country"
                      @change="restart"
                      multiple
                      clearable
                      filterable
                      :multiple-limit="3"
                      value-key="id"
                      placeholder="Please select a country"
                    >
                      <el-option
                        v-for="country in dataRangeList.countryType"
                        :key="'countryType' + country.code"
                        :label="country.descEn"
                        :value="country"
                      >
                      </el-option>
                    </el-select>
                  </div>
                  <div class="bulkData-category-select-item">
                    <div class="bulkData-category-select-title">Industry</div>
                    <el-select
                      v-model="form.industry"
                      @change="restart"
                      clearable
                      filterable
                      multiple
                      :multiple-limit="3"
                      value-key="id"
                      placeholder="Please select Industry"
                    >
                      <el-option
                        v-for="industry in dataRangeList.industryType"
                        :key="'industryType' + industry.code"
                        :label="industry.descEn"
                        :value="industry"
                      ></el-option>
                    </el-select>
                  </div>
                  <div class="bulkData-category-select-item">
                    <div class="bulkData-category-select-title">
                      Company Satus
                    </div>
                    <el-select
                      v-model="form.companySatus"
                      @change="restart"
                      clearable
                      filterable
                      multiple
                      :multiple-limit="3"
                      value-key="id"
                      placeholder="Please select"
                    >
                      <el-option
                        v-for="registrationType in dataRangeList.registrationType"
                        :key="'registrationType' + registrationType.code"
                        :label="registrationType.descEn"
                        :value="registrationType"
                      ></el-option>
                    </el-select>
                  </div>
                  <div class="bulkData-category-select-item">
                    <div class="bulkData-category-select-title">
                      Company Type
                    </div>
                    <el-select
                      v-model="form.companyType"
                      @change="restart"
                      clearable
                      filterable
                      multiple
                      :multiple-limit="3"
                      value-key="id"
                      placeholder="Please select "
                    >
                      <el-option
                        v-for="natureType in dataRangeList.natureType"
                        :key="'natureType' + natureType.code"
                        :label="natureType.descEn"
                        :value="natureType"
                      ></el-option>
                    </el-select>
                  </div>
                  <div class="bulkData-category-select-item">
                    <div class="bulkData-category-select-title">
                      Company Size
                    </div>
                    <el-select
                      v-model="form.companySize"
                      @change="restart"
                      clearable
                      multiple
                      :multiple-limit="3"
                      value-key="id"
                      placeholder="Please select "
                    >
                      <el-option
                        v-for="sizeType in dataRangeList.sizeType"
                        :key="'sizeType' + sizeType.code"
                        :label="sizeType.descEn"
                        :value="sizeType"
                      ></el-option>
                    </el-select>
                  </div>
                  <div class="bulkData-category-select-item">
                    <div class="bulkData-category-select-title">
                      Number of options
                    </div>
                    <el-select
                      v-model="form.numberOptions"
                      @change="restart"
                      clearable
                      placeholder="Please select the number of data entries"
                    >
                      <el-option
                        v-for="numberOption in dataRangeList.numberOptions"
                        :key="'numberOptions' + numberOption"
                        :label="numberOption"
                        :value="numberOption"
                      ></el-option>
                    </el-select>
                  </div>
                </div>
              </el-collapse-item>
              <el-collapse-item title="Data Dimension" name="2">
                <template slot="title">
                  <img
                    class="collapse-iconimg"
                    src="@/assets/images/dataServices/bulkData-img/selectdata.png"
                  />
                  Data Dimension
                </template>
                <div class="bulkData-dimension-container-out">
                  <div class="bulkData-dimension-container">
                    <div class="bulkData-dimension-categoryField">
                      <div class="bd-categoryField-scroll">
                        <el-collapse
                          v-model="dcDialogActiveNames"
                          class="bd-categoryField-collapse"
                        >
                          <div class="bd-categoryField-checkbox">
                            <el-collapse-item
                              v-for="(level1, index) in treeDimension"
                              :key="'category' + level1.id"
                              :title="level1.categoryNameEn"
                              :name="index"
                            >
                              <template slot="title">
                                <!-- 一级复选框 -->
                                <el-checkbox
                                  :value="isChecked(level1.id)"
                                  :indeterminate="isIndeterminate(level1)"
                                  @change="handleParentChange(level1, $event)"
                                >
                                  {{ level1.categoryNameEn }}
                                </el-checkbox>
                              </template>
                              <div
                                class="bd-categoryField-checkbox-item"
                                v-for="level2 in level1.children"
                                :key="'categorySub' + level2.id"
                              >
                                <!-- 第二层 -->
                                <el-checkbox
                                  :key="level2.id"
                                  :value="isChecked(level2.id)"
                                  @change="
                                    handleChildChange(level2.id, level1, $event)
                                  "
                                  >{{ level2.categoryNameEn }}
                                </el-checkbox>
                                <div class="bd-categoryField-checkbox-open">
                                  <i class="el-icon-arrow-right"></i>
                                </div>
                              </div>
                            </el-collapse-item>
                          </div>
                        </el-collapse>
                      </div>
                    </div>
                    <div class="bulkData-dimension-subfield">
                      <div class="bd-categoryField-scroll resultgap">
                        <div class="bd-categoryField-checkbox">
                          <!-- 第三层 -->
                          <div
                            class="bd-categoryField-checkbox-item level3"
                            v-for="level3 in level3List"
                            :key="'level3' + level3.id"
                          >
                            {{ level3.categoryNameEn }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </el-collapse-item>
            </el-collapse>
          </div>
          <div class="bulkData-select-con-right">
            <div class="bulkData-select-con-right-title">
              <img
                class="right-title-iconimg"
                src="@/assets/images/dataServices/bulkData-img/selectedColumns.png"
              />Selected Fields
            </div>
            <div class="bulkData-select-con-right-body">
              <!-- 没有选择的数据 -->
              <div
                class="bulkData-select-con-right-tip"
                v-if="!dataRangelimit && !selectedChildren.length"
              >
                Please select fields in the field category filter on the left
              </div>
              <!-- 有选择的数据 -->
              <ul class="bulkData-selected-list">
                <li class="bulkData-selected-item" v-if="dataRangelimit">
                  <div class="bulkData-selected-item-title">Data range</div>
                  <div
                    class="bulkData-selected-item-btn"
                    @click="selectActiveNames = '1'"
                  >
                    {{ dataRangelimit }} fields selected
                  </div>
                </li>
                <li
                  class="bulkData-selected-item"
                  v-if="selectedChildren.length"
                >
                  <div class="bulkData-selected-item-title">Data dimension</div>
                  <div
                    class="bulkData-selected-item-btn"
                    @click="selectActiveNames = '2'"
                  >
                    {{ selectedChildren.length }} fields selected
                  </div>
                </li>
              </ul>
            </div>
            <div class="bulkData-select-con-right-footer">
              <div class="bulkData-select-start" v-if="!taskLoading">
                <div class="bulkData-select-start-tip">
                  <img
                    src="@/assets/images/dataServices/bulkData-img/info.png"
                    alt=""
                  />
                  The selected configuration will be applied to data filtering.
                </div>
                <el-button
                  type="primary"
                  class="bulkData-select-extracting-btn"
                  :disabled="!dataRangelimit && !selectedChildren.length"
                  @click="startProduction"
                  >Start Production</el-button
                >
              </div>
              <div
                class="bulkData-select-extracting-expected flex-center-start"
                v-if="taskLoading"
              >
                <img
                  src="@/assets/images/dataServices/bulkData-img/information.png"
                  alt=""
                />
                <span>Expected completion in 3-5 days.</span>
              </div>
              <!-- 进度-不要了 -->
              <!-- <div class="bulkData-select-extracting" v-show="taskLoading">
                <div class="bulkData-select-extracting-con">
                  <div class="bulkData-select-extracting-title flex_center_bettwen">
                    <div class="flex_center_start">
                      <img
                        src="@/assets/images/dataServices/bulkData-img/extracting.png"
                        alt=""
                      />
                      <div class="text">Extracting target data fields</div>
                    </div>
                    <span>{{randomPercentage}}%</span>
                  </div>
                  <el-progress 
                  class="bulkData-ing-progress"
                  :percentage="randomPercentage" 
                  :stroke-width="8"
                  define-back-color="#ffffff"
                  color="#B98B73"
                  :show-text="false"
                  ></el-progress>
                  <div class="bulkData-select-extracting-time">Time Left: 0m 40s</div>
                </div>
                <el-button
                  type="primary" 
                  class="bulkData-select-extracting-btn"
                  >Terminate</el-button
                >
              </div> -->
            </div>
          </div>
        </div>
      </div>
      <div class="bulkData-block" v-if="page.total">
        <div class="bulkData-block-title">Data Records</div>
        <div class="bulkData-completed-table">
          <el-table
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%"
            @selection-change="handleSelectionChange"
            row-key="id"
          >
            <el-table-column
              width="60"
              type="selection"
              :selectable="rowSelectable"
              :reserve-selection="true"
              v-if="multipleSelectionShow"
            >
            </el-table-column>
            <el-table-column label="Task ID" width="300">
              <template slot-scope="scope">
                <div
                  class="bulkdata-table-tag-new"
                  v-if="scope.row.taskStatus == 1 && scope.row.viewCount == 0"
                >
                  New
                </div>
                <div style="padding-left: 10px">
                  {{ scope.row.taskId }}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="Selection" width="300">
              <template slot-scope="scope">
                <el-popover
                  popper-class="bulkData-selection-popper"
                  placement="bottom-start"
                  trigger="hover"
                  v-if="
                    scope.row.treeSelected &&
                    formatTreeSelected(scope.row.treeSelected).length
                  "
                >
                  <div slot="reference">
                    <div class="bulkdata-table-tag-list flex-between-center">
                      <template v-if="scope.row.treeSelected">
                        <div class="bulkdata-tree-overview-list">
                          {{
                            formatTreeSelected(scope.row.treeSelected)[0] &&
                            formatTreeSelected(scope.row.treeSelected)[0]
                              .categoryNameEn
                          }}
                          <span
                            v-if="formatTreeSelected(scope.row.treeSelected)[1]"
                            >\</span
                          >
                          {{
                            formatTreeSelected(scope.row.treeSelected)[1] &&
                            formatTreeSelected(scope.row.treeSelected)[1]
                              .categoryNameEn
                          }}
                        </div>
                        <div class="bulkdata-tree-overview-tag">
                          +{{
                            formatTreeSelected(scope.row.treeSelected).length
                          }}
                        </div>
                      </template>
                    </div>
                  </div>
                  <div
                    class="bulkData-selection-popper-content"
                    v-if="formatTreeSelected(scope.row.treeSelected).length"
                  >
                    <div
                      class="bulkdata-table-tag"
                      v-for="item in formatTreeSelected(scope.row.treeSelected)"
                      :key="item.id"
                    >
                      {{ item.categoryNameEn }}
                    </div>
                  </div>
                </el-popover>
              </template>
            </el-table-column>

            <el-table-column
              prop="fileSize"
              label="File size"
              width="150"
              align="center"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="createTime"
              label="Create time"
              min-width="150"
              align="right"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                {{ $formatDateTime(scope.row.createTime, "yyyy-MM-dd hh:mm") }}
              </template>
            </el-table-column>
            <el-table-column
              prop="finishTime"
              label="Completion time"
              min-width="150"
              align="right"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                {{ $formatDateTime(scope.row.finishTime, "yyyy-MM-dd hh:mm") }}
              </template>
            </el-table-column>
            <el-table-column label="Status" width="150" show-overflow-tooltip>
              <template slot-scope="scope">
                <span
                  class="point-taskStatus"
                  :class="formatTaskStatusClass(scope.row.taskStatus)"
                ></span>
                <span>{{ formatTaskStatus(scope.row.taskStatus) }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="fileExpiredRemainTime"
              label="Validity"
              align="right"
              width="150"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="name"
              label="Operation"
              align="center"
              width="200"
            >
              <template slot-scope="scope">
                <span
                  v-if="scope.row.taskStatus == 1 && !scope.row.fileExpired"
                  class="bulkdata-download-btn"
                  @click="toDownload(scope.row.id)"
                  >Download</span
                >
                <span v-else class="bulkdata-download-btn disabled"
                  >Download</span
                >
              </template>
            </el-table-column>
          </el-table>
          <div class="page_i_box dataService">
            <Page
              :totalFont="true"
              :total="page.total"
              :pageSize.sync="page.pageSize"
              :currentPage="page.pageNo"
              @onPageChange="onPageChangeList"
            ></Page>

            <div class="search_rsult_txt line_2">
              {{ page.pageNo }}-{{ page.pageSize }} of over
              {{ page.total | FilterNum }} results for "Bulk Data"
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Remind -->
    <el-dialog
      title="Remind"
      class="dialog_modal remindDialog"
      :visible.sync="remindVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="421px"
    >
      <div class="remind-dialog-content">
        <div class="remind-list">
          <div class="remind-item">
            <div class="remind-item-num">34</div>
            <div class="remind-item-title">Selected Modules</div>
          </div>
          <div class="remind-item">
            <div class="remind-item-num">64</div>
            <div class="remind-item-title">Selected Fields</div>
          </div>
          <div class="remind-item">
            <div class="remind-item-num">$32</div>
            <div class="remind-item-title">Estimated Cost</div>
          </div>
          <div class="remind-item">
            <div class="remind-item-num">122</div>
            <div class="remind-item-title">Company Count</div>
          </div>
        </div>
        <div class="remind-tips">Expected completion in 5-7 working days.</div>
      </div>
      <div class="dc-dialog-footer flex_center">
        <el-button type="primary" class="dc-remind-btn" @click="remindSubmit"
          >OK</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Header from "../../layout/header.vue";
import ToolBar from "../components/toolBar.vue";
import Page from "@/components/page/index.vue";
import { downloadFromBase64 } from "@/utils/date";
import {
  getDataRange,
  getDimenSion,
  addTask,
  queryTask,
  downloadFileByIdBD,
} from "@/api/dataServicesApi";
export default {
  components: {
    Header,
    ToolBar,
    Page,
  },
  data() {
    return {
      selectActiveNames: "1",
      form: {
        country: null,
        industry: null,
        companySatus: null,
        companyType: null,
        companySize: null,
        numberOptions: null,
      },

      toolBarData: {
        isSelectDisabled: false,
        isDownloadDisabled: true,
        isCreateComponentShow: false,
      },
      multipleSelectionShow: false,
      dataRangeList: {},
      // Data Dimension
      treeDimension: [], //全部数据
      dcDialogActiveNames: [0], //默认展开第一个一级数据
      level3List: [], //展示的第三级
      level3ListShowId: "", // 选中二级id来展示对应三级并箭头高亮
      // 使用数组存储选中的 id（保证 Vue 2 响应式）
      selectedIds: [],
      // 表格
      tableData: [],
      page: {
        pageSize: 10,
        pageNo: 1,
        total: 0,
      },
      multipleSelection: [],
      multipleDoanloadCurrent: 0,
      multipleDoanloadFinish: false,
      taskStatusOptions: [
        {
          value: "1",
          label: "Completed",
          class: "completed",
        },
        {
          value: "2",
          label: "Processing",
          class: "progress",
        },
        {
          value: "3",
          label: "Failed",
          class: "cancelled",
        },
        {
          value: "4",
          label: "Expired",
          class: "cancelled",
        },
      ],
      taskLoading: false,
      randomPercentage: 0,
      remindVisible: false,
    };
  },
  computed: {
    dataRangelimit() {
      let total = 0;
      for (const key in this.form) {
        const value = this.form[key];
        // 判断是否“已填写”
        if (Array.isArray(value)) {
          // 数组：只有 length > 0 才算填写
          if (value.length > 0) {
            total++;
          }
        } else if (typeof value === "string") {
          // 字符串：trim 后非空才算
          if (value.trim() !== "") {
            total++;
          }
        } else if (value != null) {
          // 其他类型（如 number、boolean）：非 null/undefined 即算
          total++;
        }
      }
      return total;
    },
    // ✅ 新增：只包含被选中的二级（子级）对象
    selectedChildren() {
      console.log("选择改变了");
      if (this.taskLoading) {
        this.taskLoading = false;
      }
      const result = [];
      const resultlevel3 = [];
      this.treeDimension.forEach((parent) => {
        parent.children.forEach((child) => {
          if (this.isChecked(child.id)) {
            resultlevel3.push(child);
            const { children, ...cleanChild } = child; // 剔除 id
            result.push(cleanChild);
          }
        });
      });
      console.log(result, resultlevel3);
      this.level3List = resultlevel3.flatMap(
        (level1Item) => level1Item.children || [],
      );
      return result;
    },
  },
  watch: {
    // multipleDoanloadCurrent: {
    //   handler(newVal, oldVal) {
    //     if(newVal == this.multipleSelection.length){
    //       this.queryTaskFn();
    //     }
    //   },
    //   deep: true, // 深度监听，可以监听对象内部属性的变化
    //   immediate: true, // 立即执行一次handler函数，即使columns没有变化
    // },
    // multipleDoanloadFinish: {
    //   handler(newVal, oldVal) {
    //     if(newVal){
    //       this.queryTaskFn();
    //     }
    //   },
    //   deep: true, // 深度监听，可以监听对象内部属性的变化
    //   immediate: true, // 立即执行一次handler函数，即使columns没有变化
    // },
  },
  mounted() {
    // 主题色
    this.$store.dispatch("app/setThemColor", "#B98B73");
    this.$store.dispatch("app/setSearchType", "dataServices");
    this.getDataRangeFn(); //调一次存起来
    this.getDimenSionFn(); //调一次存起来
    this.queryTaskFn();
  },
  methods: {
    remindSubmit() {
      this.remindVisible = false;
    },
    async getDataRangeFn() {
      let arrData = localStorage.getItem("bulkDataServiceRange");
      if (arrData) {
        this.dataRangeList = JSON.parse(
          localStorage.getItem("bulkDataServiceRange"),
        );
        return;
      }
      await getDataRange().then((res) => {
        if (res.code == 200 && res.data) {
          this.dataRangeList = res.data;
          localStorage.setItem(
            "bulkDataServiceRange",
            JSON.stringify(res.data),
          );
        }
      });
    },
    async getDimenSionFn() {
      let arrData = localStorage.getItem("bulkDataServiceDimension");
      if (arrData) {
        this.treeDimension = JSON.parse(
          localStorage.getItem("bulkDataServiceDimension"),
        );
        // this.level3ListShowId = this.treeDimension[0].children[0].id;
        // this.level3List = this.treeDimension[0].children[0].children;
        return;
      }
      await getDimenSion().then((res) => {
        console.log("获取树形结构DataDimension", res);
        if (res.code == 200 && res.data.length > 0) {
          this.treeDimension = res.data;
          localStorage.setItem(
            "bulkDataServiceDimension",
            JSON.stringify(res.data),
          );
          // this.level3ListShowId = this.treeDimension[0].children[0].id;
          // this.level3List = this.treeDimension[0].children[0].children;
        }
      });
    },
    showLevel3List(row) {
      this.level3List = row.children;
      this.level3ListShowId = row.id;
    },
    // 树形
    // 判断某个 id 是否被选中
    isChecked(id) {
      return this.selectedIds.indexOf(id) !== -1;
    },
    // 安全添加 id（避免重复）
    addId(id) {
      if (!this.isChecked(id)) {
        this.selectedIds.push(id);
      }
    },
    // 安全移除 id
    removeId(id) {
      const index = this.selectedIds.indexOf(id);
      if (index !== -1) {
        this.selectedIds.splice(index, 1);
      }
    },
    // 判断父节点是否处于“半选”状态
    isIndeterminate(parent) {
      const childIds = parent.children.map((c) => c.id);
      const checkedCount = childIds.filter((id) => this.isChecked(id)).length;
      return checkedCount > 0 && checkedCount < childIds.length;
    },
    // 父节点复选框变化
    handleParentChange(parent, checked) {
      const childIds = parent.children.map((c) => c.id);
      if (checked) {
        // 全选：添加父 + 所有子
        this.addId(parent.id);
        childIds.forEach((id) => this.addId(id));
      } else {
        // 取消：移除父 + 所有子
        this.removeId(parent.id);
        childIds.forEach((id) => this.removeId(id));
      }
    },
    // 子节点复选框变化
    handleChildChange(childId, parent, checked) {
      if (checked) {
        this.addId(childId);
      } else {
        this.removeId(childId);
      }
      // 更新父节点状态：根据子项选中情况决定是否勾选父节点
      const childIds = parent.children.map((c) => c.id);
      const checkedCount = childIds.filter((id) => this.isChecked(id)).length;

      if (checkedCount === childIds.length) {
        // 所有子项都选中 → 勾选父节点
        this.addId(parent.id);
      } else {
        // 否则取消父节点（即使之前勾选了）
        this.removeId(parent.id);
      }
    },
    // 树形结束
    async getParamsCountry(list, type) {
      const idString = list
        .filter((item) => item[type] != null) // 排除 id 为 null/undefined 的项
        .map((item) => item[type])
        .join(",");
      return idString;
    },
    async startProduction() {
      console.log("开始生成");
      console.log("form", this.form);

      let {
        country,
        industry,
        companySatus,
        companyType,
        companySize,
        numberOptions,
      } = this.form;
      let params = {
        country: await this.getParamsCountry(country, "descEn"),
        countryCode: await this.getParamsCountry(country, "code"),
        industry: await this.getParamsCountry(industry, "descEn"),
        industryCode: await this.getParamsCountry(industry, "code"),
        companyStatus: await this.getParamsCountry(companySatus, "descEn"),
        companyStatusCode: await this.getParamsCountry(companySatus, "code"),
        companyType: await this.getParamsCountry(companyType, "descEn"),
        companyTypeCode: await this.getParamsCountry(companyType, "code"),
        companySize: await this.getParamsCountry(companySize, "descEn"),
        companySizeCode: await this.getParamsCountry(companySize, "code"),
        numberOptions: numberOptions,
        treeSelected: JSON.stringify(this.selectedChildren),
      };
      console.log("参数", params);
      await addTask(params).then((res) => {
        console.log("提交任务", res);
        if (res.code == 200) {
          console.log("11111111");
          this.taskLoading = true;
          this.$message.success(res.msg);
          // this.remindVisible = true;
          this.queryTaskFn();
        } else {
          this.taskLoading = false;
          this.$message.error(res.msg);
        }
      });
    },
    restart() {
      if (this.taskLoading) {
        this.taskLoading = false;
      }
    },
    onPageChangeList({ page, size }) {
      this.page.pageSize = size;
      this.page.pageNo = page;
      this.queryTaskFn();
    },
    async toDownload(id) {
      // await this.downloadCommon(id, 'single');
      // this.queryTaskFn();
      // try {
      //   await this.downloadFile(id);
      //   await this.queryTaskFn();
      //   this.$message.success('下载完成，列表已刷新');
      // } catch (error) {
      //   console.log(error);
      //   this.$message.error('下载或刷新失败');
      // }
      await this.downloadFile(id); // 不会抛错
      await this.queryTaskFn(); // 刷新列表
      this.$message.success("Success");
    },
    async handleDownload() {
      // this.multipleDoanloadCurrent = 0;
      // this.multipleDoanloadFinish = false;
      // this.multipleSelection.forEach(item => {
      //   this.downloadCommon(item.id, 'multiple');
      // });
      // this.queryTaskFn();
      // 并发下载所有（每个 downloadFile 都 resolve）
      await Promise.all(
        this.multipleSelection.map((id) => this.downloadFile(id)),
      );

      // 全部完成后，只刷新一次
      await this.queryTaskFn();
      this.$message.success("Success");
    },
    // 下载公共方法
    async downloadFile(id) {
      try {
        // 调用你原始的 API
        const res = await downloadFileByIdBD(`?id=${id}`);
        if (res.code == 200) {
          // 截取文件后缀名 查看属于什么文件
          let fileType = res.msg.split(".").pop().toLowerCase();
          var downloadType = "";
          if (fileType == "pdf") {
            downloadType = "application/pdf";
          } else if (fileType == "docx") {
            downloadType =
              "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
          } else if (fileType == "doc") {
            downloadType = "application/msword";
          } else if (fileType == "xls") {
            downloadType = "application/vnd.ms-excel";
          } else if (fileType == "xlsx") {
            downloadType =
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
          } else if (fileType == "csv") {
            downloadType = "text/csv;charset=utf-8";
          }
          downloadFromBase64(res.data, downloadType, res.msg);
        } else {
          this.$message.error(res.msg);
        }
      } catch (error) {
        console.log(error);
        // // 捕获 axios 错误（500/404/网络问题等）
        // const errMsg = error.response?.data?.msg ||
        //               error.message ||
        //               '请求失败，请稍后重试';
        // this.$message.error(errMsg);
        // // ⚠️ 关键：不 throw，让函数正常 resolve
      }
    },
    async downloadCommon(id, type) {
      downloadFileByIdBD(`?id=${id}`).then((res) => {
        if (res.code == 200) {
          // 截取文件后缀名 查看属于什么文件
          let fileType = res.msg.split(".").pop().toLowerCase();
          var downloadType = "";
          if (fileType == "pdf") {
            downloadType = "application/pdf";
          } else if (fileType == "docx") {
            downloadType =
              "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
          } else if (fileType == "doc") {
            downloadType = "application/msword";
          } else if (fileType == "xls") {
            downloadType = "application/vnd.ms-excel";
          } else if (fileType == "xlsx") {
            downloadType =
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
          } else if (fileType == "csv") {
            downloadType = "text/csv;charset=utf-8";
          }
          downloadFromBase64(res.data, downloadType, res.msg);
          if (type == "single") {
            this.multipleDoanloadFinish = true;
          } else if (type == "multiple") {
            this.multipleDoanloadCurrent++;
          }
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    async queryTaskFn() {
      let params = {
        page: this.page.pageNo,
        pageSize: this.page.pageSize,
      };
      console.log("参数", params);
      await queryTask(params).then((res) => {
        console.log("获取列表", JSON.parse(JSON.stringify(res)));
        this.tableData = res.data.rows;
        this.page.total = res.data.total;
      });
    },
    formatTreeSelected(data) {
      if (data) {
        return JSON.parse(data);
      }
      return [];
    },
    formatTaskStatus(status) {
      const item = this.taskStatusOptions.find((item) => item.value == status);
      return item ? item.label : null;
    },
    formatTaskStatusClass(status) {
      const item = this.taskStatusOptions.find((item) => item.value == status);
      return item.class;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val.map((row) => row.id);
      if (this.multipleSelection.length > 0) {
        this.toolBarData.isDownloadDisabled = false;
      } else {
        this.toolBarData.isDownloadDisabled = true;
      }
    },
    // ✅ 控制每行是否可选
    rowSelectable(row, index) {
      // fileExpired true时按钮置灰,表示过期
      return row.taskStatus == 1 && !row.fileExpired;
    },
    handleSelect() {
      console.log(this.multipleSelectionShow);
      this.multipleSelectionShow = !this.multipleSelectionShow;
      if (!this.multipleSelectionShow) {
        this.multipleSelection = [];
      }
    },
  },
};
</script>
<style scoped>
.bulkData-container {
  width: 100%;
  padding: 20px;
  margin-top: 56px;
  overflow-y: auto;
}
.bulkData-block {
  background: #ffffff;
  border-radius: 10px;
  padding: 30px 36px;
  margin-bottom: 20px;
}
.bulkData-block-title {
  height: 28px;
  font-weight: bold;
  font-size: 20px;
  color: #1a2332;
  text-align: left;
  margin-bottom: 20px;
}
.bulkData-select-con {
  /* height: 780px; */
  height: calc(100vh - 280px);
  position: relative;
  min-height: 345px;
}
.bulkData-select-con-left {
  flex: 1;
  height: 100%;
  overflow-y: auto;
  margin-right: 600px;
}
.el-collapse.bulkData-category-collapse {
  border: 0;
}
.bulkData-category-collapse /deep/ .el-collapse-item {
  background: #ffffff;
  border-radius: 10px;
  border: 1px solid #cccccc;
}
.bulkData-category-collapse /deep/ .el-collapse-item:first-of-type {
  margin-bottom: 20px;
}
.bulkData-category-collapse /deep/ .el-collapse-item__header {
  height: 60px;
  line-height: 60px;
  border-radius: 10px;
  font-weight: bold;
  font-size: 20px;
  color: #1a2332;
  padding: 0 19px;
  border: 0;
}
.bulkData-category-collapse /deep/ .el-collapse-item__header .collapse-iconimg {
  margin-right: 10px;
}
.bulkData-category-collapse
  /deep/
  .el-collapse-item__header
  .el-icon-arrow-right:before {
  font-size: 14px;
  color: #1a2332;
  font-weight: bold;
}
.bulkData-category-collapse
  /deep/
  .el-collapse-item__header
  .el-collapse-item__arrow.is-active {
  transform: rotate(-90deg);
}
.bulkData-category-collapse
  /deep/
  .el-collapse-item__header
  .el-checkbox
  .el-checkbox__label {
  vertical-align: middle;
}
.bulkData-category-collapse /deep/ .el-collapse-item__wrap {
  border: 0;
  border-radius: 10px;
  padding: 6px 25px;
}
.bulkData-category-collapse /deep/ .el-collapse-item__content {
  padding-bottom: 0;
}
.bulkData-category-select-title {
  font-size: 16px;
  color: #000000;
  height: 21px;
  line-height: 21px;
  margin-bottom: 13px;
  font-weight: bold;
}
.category-collapse-head-tip {
  font-size: 16px;
  color: #999999;
  margin: 0 10px;
  font-weight: normal;
}
.bulkData-category-select-box {
  display: flex;
  flex-wrap: wrap;
}
.bulkData-category-select-box .el-select {
  width: 100%;
}
.bulkData-category-select-item {
  margin-bottom: 20px;
  width: 50%;
}
.bulkData-category-select-item:nth-of-type(odd) {
  padding-right: 24px;
}
.bulkData-category-select-item /deep/ .el-input__inner {
  font-size: 14px;
  color: #1a2332;
}
.bulkData-category-select-item /deep/.el-input__inner::placeholder {
  font-size: 16px;
  color: #999999;
}
.bulkData-category-select-item /deep/ .el-tag.el-tag--info {
  background-color: #faf1ec;
  border-color: #faf1ec;
  border-radius: 40px;
  font-size: 16px;
  color: #b98b73;
  padding: 4px 14px;
  height: 30px;
}
.bulkData-category-select-item /deep/ .el-tag.el-tag--info .el-tag__close {
  color: #b98b73;
  font-size: 14px;
  font-weight: bold;
  background: transparent;
}
/* 选择 左右结构 */
.bulkData-dimension-container-out {
  padding: 20px;
  background: #f5f5f5;
  border-radius: 10px;
  height: calc(100vh - 436px);
  min-height: 300px;
}
.bulkData-dimension-container {
  display: flex;
  background: #ffffff;
  border-radius: 10px;
  border: 1px solid #cccccc;
  height: 100%;
  /* height: calc(100vh - 500px); */
}
.bulkData-dimension-categoryField {
  width: 53%;
  border-right: 1px solid #ccc;
  flex-shrink: 0;
  padding: 20px 0;
}
.bd-categoryField-scroll {
  height: 100%;
  overflow-y: auto;
}
.bd-categoryField-scroll.resultgap {
  padding: 0 20px;
}
.bd-categoryField-collapse {
  border: 0;
}
.bd-categoryField-collapse /deep/ .el-collapse-item__header {
  font-size: 14px;
  color: #1a2332;
  height: 40px;
  line-height: 30px;
  padding: 7px 34px 4px 30px;
  border: 0;
  background: #ffffff;
  font-weight: normal;
  border-radius: 0;
}
.bd-categoryField-collapse /deep/ .el-collapse-item {
  border: 0;
  margin-bottom: 0;
}
.bd-categoryField-collapse /deep/ .el-collapse-item:first-of-type {
  margin-bottom: 0;
}
.bd-categoryField-collapse /deep/ .el-collapse-item__header.is-active {
  color: #b98b73;
  background: #f5f5f5;
}
.bd-categoryField-collapse /deep/ .el-collapse-item__wrap {
  border: 0;
  background: #f5f5f5;
  border-radius: 0;
  padding: 0;
}
.bd-categoryField-collapse /deep/ .el-collapse-item__content {
  padding: 2px 34px 2px 60px;
}
.bd-categoryField-collapse
  /deep/
  .el-collapse-item__header
  .el-collapse-item__arrow {
  transform: rotate(90deg);
}
.bd-categoryField-collapse
  /deep/
  .el-collapse-item__header
  .el-icon-arrow-right:before {
  font-weight: normal;
  font-size: 14px;
}
.bd-categoryField-collapse
  /deep/
  .el-collapse-item__header
  .el-icon-arrow-right.is-active:before {
  color: #b98b73;
}
.bd-categoryField-checkbox /deep/ .el-checkbox .el-checkbox__label {
  font-size: 16px;
  color: #1a2332;
  line-height: 30px;
  white-space: normal;
  vertical-align: top;
  padding-right: 20px;
}
.bd-categoryField-checkbox
  /deep/
  .el-checkbox__input.is-indeterminate
  .el-checkbox__inner {
  background: #b98b73;
}

.bd-categoryField-checkbox-item {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 6px 0;
}
.bd-categoryField-checkbox-item.level3 {
  font-size: 16px;
  color: #1a2332;
  line-height: 30px;
}
.bd-categoryField-checkbox-item /deep/ .el-checkbox__input {
  vertical-align: text-top;
}

.bd-categoryField-checkbox-open {
  width: 20px;
  height: 30px;
  line-height: 30px;
  font-size: 20px;
  /* cursor: pointer; */
}
.bd-categoryField-checkbox-open.active {
  color: #b98b73;
}
.bulkData-dimension-subfield {
  flex: 1;
  padding: 20px 0;
}
.bulkData-select-con-right {
  position: absolute;
  right: 0;
  top: 0;
  width: 567px;
  height: 100%;
  flex-shrink: 0;
  background: #ffffff;
  border-radius: 10px 10px 10px 10px;
  border: 1px solid #cccccc;
  padding: 30px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.bulkData-select-con-right-title {
  font-weight: bold;
  font-size: 20px;
  color: #1a2332;
  height: 30px;
  line-height: 30px;
  flex-shrink: 0;
}
.bulkData-select-con-right-title > .right-title-iconimg {
  vertical-align: text-top;
  margin-right: 10px;
}
.bulkData-select-con-right-tip {
  width: 100%;
  height: 50px;
  background: #f5f5f5;
  border-radius: 10px;
  border: 1px solid #cccccc;
  line-height: 50px;
  text-align: center;
  color: #999999;
  font-weight: 400;
  font-size: 16px;
  color: #999999;
}
.bulkData-select-con-right-body {
  flex: 1;
  padding: 16px 0;
  overflow-y: auto;
}
.bulkData-select-con-right-footer {
  padding: 10px 0;
}
.bulkData-select-extracting {
  width: 507px;
  height: 219px;
  background: #f5f5f5;
  border-radius: 10px 10px 10px 10px;
  border: 1px solid #cccccc;
  padding: 24px;
}
.bulkData-select-extracting-btn {
  width: 100%;
  height: 50px;
}
.bulkData-select-extracting-title {
  font-size: 14px;
  color: #b98b73;
}
.bulkData-select-extracting-title .text {
  padding: 0 10px;
}
.bulkData-select-extracting-title .text.finish {
  color: #1a2332;
}
.bulkData-ing-progress {
  margin: 20px 0 16px;
}
.bulkData-select-extracting-con {
  margin-bottom: 33px;
}
.bulkData-select-extracting-time {
  font-weight: 400;
  font-size: 14px;
  color: #999999;
  text-align: right;
}
.bulkData-select-extracting-expected {
  width: 100%;
  font-weight: 400;
  font-size: 14px;
  color: #1a2332;
  text-align: left;
  font-style: normal;
  padding: 21px 22px;
  background: #f5f5f5;
  border-radius: 10px 10px 10px 10px;
  border: 1px solid #cccccc;
  gap: 0 12px;
}
.bulkData-selected-item {
  margin-bottom: 20px;
}
.bulkData-selected-item-title {
  font-weight: 400;
  font-size: 20px;
  color: #1a2332;
  text-align: left;
  margin-bottom: 20px;
}
.bulkData-selected-item-btn {
  width: 100%;
  height: 42px;
  line-height: 40px;
  background: #faf1ec;
  border-radius: 30px;
  text-align: center;
  border: 1px solid #faf1ec;
  font-size: 20px;
  color: #b98b73;
  transition: all 0.1s;
  cursor: pointer;
}
.bulkData-selected-item-btn:hover,
.bulkData-selected-item-btn.active {
  border-color: #b98b73;
}
.bulkData-select-start-tip {
  font-size: 16px;
  color: #999999;
  border-bottom: 1px solid #ccc;
  padding: 18px 0;
  margin-bottom: 25px;
}
.bulkData-select-start-tip > img {
  vertical-align: middle;
  margin-right: 10px;
}
.bulkdata-download-btn {
  font-weight: 400;
  font-size: 16px;
  color: #b98b73;
  line-height: 30px;
  font-style: normal;
  cursor: pointer;
}
.bulkdata-download-btn.disabled {
  color: #dfcec5;
  cursor: not-allowed;
}
/* 表格样式 */
.bulkData-completed-table /deep/ th.el-table__cell {
  border: 0;
  padding: 8px 0 8px 10px
}
.bulkData-completed-table /deep/ td.el-table__cell {
  padding: 13px 0 13px 10px;
}
.bulkData-completed-table
  /deep/
  .el-table--enable-row-hover
  .el-table__body
  tr:hover
  > td.el-table__cell {
  background-color: #ffffff;
}
.bulkData-completed-table /deep/ .cell {
  font-size: 16px;
  line-height: 30px !important;
}
.bulkdata-table-tag-new {
  display: inline-block;
  height: 22px;
  line-height: 22px;
  background: #faf1ec;
  border-radius: 30px;
  padding: 0px 6px;
  font-size: 14px;
  color: #b98b73;
  position: absolute;
  top: 5px;
  left: 10px;
}
.point-taskStatus {
  width: 8px;
  height: 8px;
  background: #ccc;
  display: inline-block;
  vertical-align: middle;
  border-radius: 50%;
  margin-right: 8px;
}
.point-taskStatus.completed {
  background: #02815c;
}
.point-taskStatus.progress {
  background: #fe9e42;
}
.point-taskStatus.regenerating {
  background: #ffa52d;
}
.point-taskStatus.cancelled {
  background: #f55656;
}
.point-taskStatus.cleaningCompleted {
  background: #b98b73;
}
.bulkdata-table-tag-list {
  display: flex;
  gap: 8px;
  width: 270px;
  border: 1px solid #cccccc;
  padding: 5px 8px 5px 16px;
  border-radius: 20px;
  align-items: center;
}
.bulkdata-table-tag-list:hover {
  border-color: #b98b73;
}
.bulkdata-tree-overview-list {
  height: 20px;
  line-height: 20px;
  border-radius: 6px;
  font-weight: 400;
  font-size: 16px;
  color: #1a2332;
  text-align: left;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.bulkdata-tree-overview-tag {
  width: 43px;
  height: 26px;
  line-height: 26px;
  background: #f5f5f5;
  border-radius: 20px;
  text-align: center;
  font-size: 16px;
  color: #999999;
  flex-shrink: 0;
}
.bulkdata-table-tag {
  height: 33px;
  line-height: 33px;
  background: #f5f5f5;
  border-radius: 6px;
  text-align: center;
  padding: 0 8px;
  font-size: 16px;
  color: #1a2332;
}
.bulkdata-table-tag-list .bulkdata-table-tag:last-of-type {
  flex: 1;
}
.bulkData-selection-popper-content {
  display: flex;
  gap: 10px 12px;
  flex-wrap: wrap;
}
.bulkData-selection-popper-content .bulkdata-table-tag {
  width: auto;
}
@media (max-width: 1920px) {
  /* 标题字体 20px */
  .bulkData-block-title,
  .bulkData-category-collapse /deep/ .el-collapse-item__header,
  .bulkData-select-con-right-title,
  .bulkData-selected-item-title
  {
    font-size: 20px !important;
  }
  /* 文本字体 16px */
  .category-collapse-head-tip,
  .bulkData-category-select-title,
  .bulkData-select-start-tip,
  .bd-categoryField-checkbox /deep/ .el-checkbox .el-checkbox__label,
  .bulkData-selected-item-btn,
  .bd-categoryField-checkbox-item.level3,
  .bulkData-select-extracting-btn,
  .bulkData-category-select-item /deep/ .el-tag.el-tag--info,
  .bulkdata-tree-overview-list,
  .bulkdata-table-tag,
  .bulkData-completed-table /deep/ .cell,
  .bulkData-category-select-item /deep/.el-input__inner::placeholder,
  .bulkdata-tree-overview-tag
  {
    font-size: 16px !important;
  }
  /* 表格 */
  .bulkData-completed-table /deep/ thead {
    height: auto !important;
  }
  .bulkData-completed-table /deep/ th.el-table__cell,
  .bulkData-completed-table /deep/ .has-gutter .el-table__cell {
    height: auto !important;
    padding: 7px 0 7px 10px;
  }
  .bulkData-completed-table /deep/ td.el-table__cell {
    padding: 6px 0;
  }
  /* 圆角 */
  
  /* padding + margin  */
  .bulkData-container{
    padding: 15px;
    margin-top: 45px;
  }
  .bulkData-block{
    padding: 22px 27px;
    margin-bottom: 15px;
  }
  .bulkData-block-title{
    margin-bottom: 15px;
  }
  /* 其他 */
  .bulkData-select-con-right{
    padding: 22px;
  }
}
@media (max-width: 1440px) {
  /* 标题字体 18px */
  .bulkData-block-title,
  .bulkData-category-collapse /deep/ .el-collapse-item__header,
  .bulkData-select-con-right-title,
  .bulkData-selected-item-title
  {
    font-size: 18px !important;
  }
  /* 文本字体 14px */
  .category-collapse-head-tip,
  .bulkData-category-select-title,
  .bulkData-select-start-tip,
  .bd-categoryField-checkbox /deep/ .el-checkbox .el-checkbox__label,
  .bulkData-selected-item-btn,
  .bd-categoryField-checkbox-item.level3,
  .bulkData-select-extracting-btn,
  .bulkData-category-select-item /deep/ .el-tag.el-tag--info,
  .bulkdata-tree-overview-list,
  .bulkdata-table-tag,
  .bulkData-completed-table /deep/ .cell,
  .bulkData-category-select-item /deep/.el-input__inner::placeholder,
  .bulkdata-tree-overview-tag
  {
    font-size: 14px !important;
  }
  /* 表格 */
  .bulkData-completed-table /deep/ thead {
    height: auto !important;
  }
  .bulkData-completed-table /deep/ th.el-table__cell,
  .bulkData-completed-table /deep/ .has-gutter .el-table__cell {
    height: auto !important;
    padding: 5px 0 5px 10px;
  }
  .bulkData-completed-table /deep/ td.el-table__cell {
    padding: 6px 0;
  }
  .bulkdata-table-tag-list{
    padding: 1px 8px 1px 16px;
  }
  .bulkdata-tree-overview-tag{
    height: 20px;
    line-height: 20px;
  }
  /* 圆角 */
  
  /* padding + margin  */
  .bulkData-container{
    padding: 13px;
  }
  .bulkData-block{
    padding: 20px 24px;
    margin-bottom: 13px;
  }
  .bulkData-block-title{
    margin-bottom: 13px;
  }
  /* 其他 */
  .bulkData-select-con-right{
    padding: 20px;
  }
  /* 原来的 */
  .bulkData-select-con {
    height: calc(100vh - 230px);
  }
  .bd-categoryField-checkbox /deep/ .el-checkbox .el-checkbox__label {
    line-height: 24px;
  }
  .bd-categoryField-checkbox-open {
    height: 24px;
    line-height: 24px;
  }
  .bulkData-dimension-container-out {
    height: calc(100vh - 386px);
  }
}

</style>
